module.exports = __webpack_public_path__ + "img/agentPay - darkLogo.638ca72a.svg";